import table from './src/table';
import vue from "vue";
export default table;
export const util = {
    event: new vue()
}